/**
 * This function uploads a file to S3 using a signed URL.
 *
 * @param file
 */
export async function temporaryS3Store(file: File) {
  const response = await window.axios.post('/api/v1/signed-storage-url', {
    content_type: file.type,
  });

  let headers = response.data.headers;

  if ('Host' in headers) {
    delete headers.Host;
  }

  await window.axios.put(response.data.url, file, {
    headers: headers,
  });

  response.data.extension = file.name.split('.').pop();

  return response.data;
}
